const equipmentCategory = {
  AUTOMATION: 'Automation',
  BRIDGE_EQUIPMENT: 'Bridge Equipment',
  CARGO_HANDLING: 'Cargo Handling',
  ELECTRICAL_ELECTRONIC: 'Electrical/Electronic',
  FI_FI_LIFE_SAVING_EQUIPMENT: 'Fi-Fi/Life Saving Equipment',
  HULL: 'Hull',
  HULL_OUTFITTING: 'Hull Outfitting',
  MACHINERY_EQUIPMENT: 'Machinery Equipment',
  REGULATORY_COMPLIANCE_AND_COMMERCIAL_INSPECTIONS:
    'Regulatory Compliance and Commercial Inspections',
};

const equipmentSubcategory = {
  AIR_COMPRESSORS_DRYERS: 'Air Compressors/Dryers',
  AUXILIARY_ENGINES: 'Auxiliary Engines',
  ENGINE_ROOM_PUMPS: 'Engine Room Pumps',
  FW_GENERATOR: 'FW Generator',
  HEAT_EXCHANGERS: 'Heat Exchangers',
  HVAC: 'HVAC',
  MAIN_ENGINE: 'Main Engine',
  PURIFIERS: 'Purifiers',
  RADARS: 'Radars',
  SHAFTING: 'Shafting',
  STEAM_GENERATING_PLANT: 'Steam Generating Plant',
  WINCHES: 'Winches',
};

const equipmentTitle = {
  _3D_SCANNING: '3D Scanning',
  ACBS: 'ACBs',
  ACCOMMODATION_LADDERS: 'Accommodation Ladders',
  AIRCOOLER: 'Aircooler',
  AIS: 'AIS',
  ALARM_MONITORING_SYSTEM: 'Alarm Monitoring System',
  ANCHORS: 'Anchors',
  ATMOSPHERIC_CONDENSER: 'Atmospheric Condenser',
  ATTACHED_PUMPS: 'Attached Pumps',
  AUTO_PILOT: 'Auto Pilot',
  AUTOMATIC_UNLOADING_SYSTEM: 'Automatic Unloading System',
  AUXILIARY_BLOWERS: 'Auxiliary Blowers',
  AUXILIARY_BOILER: 'Auxiliary Boiler',
  AUXILIARY_BOILERS_FUEL_OIL_HEATERS: 'Auxiliary Boilers Fuel Oil Heaters',
  AUXILIARY_CONDENSER: 'Auxiliary Condenser',
  AUXILIARY_ENGINES: 'Auxiliary Engines',
  AUX_BOILER_FEED_WATER_PUMPS: 'Aux Boiler Feed Water Pumps',
  AVR: 'AVR',
  BALLAST_PUMPS: 'Ballast Pumps',
  BALLAST_WATER_SAMPLING: 'Ballast Water Sampling',
  BALLAST_WATER_TREATMENT_SYSTEM: 'Ballast Water Treatment System',
  BAR_CODE_SPARES_INVENTORY: 'Bar Code Spares Inventory',
  BEARINGS: 'Bearings',
  BILGE_TRANSFER_PUMP: 'Bilge Transfer Pump',
  BNWAS: 'BNWAS',
  BOW_THRUSTER: 'Bow Thruster',
  BREATHING_APPARATUSES: 'Breathing Apparatuses',
  CALORIFIER: 'Calorifier',
  CAMSHAFT_CRANKSHAFT: 'Camshaft/Crankshaft',
  CARGO_COMPRESSORS: 'Cargo Compressors',
  CARGO_CONTROL_CONSOLE: 'Cargo Control Console',
  CARGO_GEAR_HHC: 'Cargo Gear/HHC',
  CARGO_GRABS: 'Cargo Grabs',
  CARGO_HEAT_EXCHANGERS: 'Cargo Heat Exchangers',
  CARGO_HOLD_HATCHES: 'Cargo Hold Hatches',
  CARGO_LOADING_COMPUTER: 'Cargo Loading Computer',
  CARGO_MONITORING_SYSTEM_LTP: 'Cargo Monitoring System (LTP)',
  CARGO_PUMPS: 'Cargo Pumps',
  CARGO_TANKS_AND_INSULATION: 'Cargo Tanks and Insulation',
  CARGO_TURBINES: 'Cargo Turbines',
  CCTV: 'CCTV',
  CENTRAL_FW_COOLERS: 'Central FW Coolers',
  CENTRAL_FW_PUMP: 'Central FW Pump',
  CO2_SYSTEM: 'CO2 System',
  COMPOSITE_BOILER: 'Composite Boiler',
  CONDITION_ASSESSMENT_SURVEYS: 'Condition Assessment Surveys',
  CONTROL_AIR_COMPRESSOR: 'Control Air Compressor',
  CONTROL_AIR_DRYER: 'Control Air Dryer',
  CPP: 'CPP',
  CRANKSHAFT: 'Crankshaft',
  CYLINDER_HEADS: 'Cylinder Heads',
  DO_COOLERS: 'DO Coolers',
  DO_PURIFIERS: 'DO Purifiers',
  DRAIN_COOLER: 'Drain Cooler',
  DRY_POWDER_SYSTEM: 'Dry Powder System',
  ECDIS: 'ECDIS',
  ECHO_SOUNDER: 'Echo Sounder',
  ECONOMIZER: 'Economizer',
  ECR_A_C_UNIT: 'ECR A/C Unit',
  ECR_CONSOLE: 'ECR Console',
  EEBDS: 'EEBDs',
  EJECTOR_PUMP: 'Ejector Pump',
  ELECTRIC_MOTORS: 'Electric Motors',
  ELEVATOR: 'Elevator',
  EMERGENCY_DIESEL_GENERATOR: 'Emergency Diesel Generator',
  EMERGENCY_FIRE_PUMP: 'Emergency Fire Pump',
  ENGINE_ROOM_CRANE: 'Engine Room Crane',
  ENGINE_ROOM_PUMPS: 'Engine Room Pumps',
  ENGINE_ROOM_TEMPERATURE_CONTROLLERS: 'Engine Room Temperature Controllers',
  ENGINE_ROOM_VENTILATION_FANS: 'Engine Room Ventilation Fans',
  EPIRB: 'EPIRB',
  ESD_SYSTEM: 'ESD System',
  EXHAUST_CLEANING_SYSTEM_ANALYSIS: 'Exhaust Cleaning System Analysis',
  EXHAUST_VALVES: 'Exhaust Valves',
  FIRE_BILGE_GS_PUMPS: 'Fire Bilge GS Pumps',
  FIRE_DETECTION_SYSTEM: 'Fire Detection System',
  FIRE_PUMP: 'Fire Pump',
  FIREMAN_OUTFITS: 'Fireman Outfits',
  FIVA_CONTROL_SYSTEM: 'FIVA/Control System',
  FOAM_SYSTEM: 'Foam System',
  FORCED_DRAFT_FAN: 'Forced Draft Fan',
  FO_BOOSTER_CIRCULATING_PUMPS: 'FO Booster/Circulating Pumps',
  FO_BOOSTER_MODULE: 'FO Booster Module',
  FO_HEATERS: 'FO Heaters',
  FO_PURIFIERS: 'FO Purifiers',
  FO_SUPPLY_PUMPS: 'FO Supply Pumps',
  FO_TRANSFER_PUMP: 'FO Transfer Pump',
  FUEL_GAS_SYSTEM: 'Fuel Gas System',
  FUEL_PUMPS: 'Fuel Pumps',
  FW_COOLERS: 'FW Coolers',
  FW_GENERATOR: 'FW Generator',
  GAS_ADMISSION_VALVE: 'Gas Admission Valve',
  GAS_DETECTION_SYSTEM: 'Gas Detection System',
  GEARBOX: 'Gearbox',
  GENERATORS: 'Generators',
  GENERATOR_ENGINE_FUEL_OIL_HEATER: 'Generator Engine Fuel Oil Heater',
  GOVERNOR: 'Governor',
  GPS: 'GPS',
  GYRO_COMPASSES: 'Gyro Compasses',
  HARBOUR_COOLING_SW_PUMP: 'Harbour Cooling SW Pump',
  HAZARDOUS_MATERIAL_INVENTORY: 'Hazardous Material Inventory',
  HT_COOLING_PUMPS: 'HT cooling Pumps',
  ICCP: 'ICCP',
  IG_DECK_SEAL_WATER_PUMPS: 'IG Deck Seal Water Pumps',
  IMMERSION_SUITS: 'Immersion Suits',
  INCIDENT_INVESTIGATIONS: 'Incident Investigations',
  INCINERATOR: 'Incinerator',
  INERT_GAS_SYSTEM: 'Inert Gas System',
  INJECTORS: 'Injectors',
  INMARSAT_C: 'Inmarsat-C',
  INTERMEDIATE_BEARING: 'Intermediate Bearing',
  INTERMEDIATE_SHAFT: 'Intermediate Shaft',
  JACKET_COOLING_FW_PUMPS: 'Jacket Cooling FW Pumps',
  LIFEBOAT_RESCUE_BOAT: 'Lifeboat/Rescue Boat',
  LIFEBOAT_OXYGEN: 'Lifeboat Oxygen',
  LIFERAFTS: 'Liferafts',
  LIFE_BOAT_DAVITS: 'Life Boat Davits',
  LINERS: 'Liners',
  LO_COOLERS: 'LO Coolers',
  LO_PURIFIERS: 'LO Purifiers',
  LO_TRANSFER_PUMPS: 'LO Transfer Pumps',
  LRIT: 'LRIT',
  LT_COOLING_PUMPS: 'LT Cooling Pumps',
  LUBRICATING_OIL_COOLER: 'Lubricating Oil Cooler',
  LUBRICATOR_SYSTEM: 'Lubricator System',
  MAGNETIC_COMPASS: 'Magnetic Compass',
  MAIN_AIR_COMPRESSORS: 'Main Air Compressors',
  MAIN_A_C_UNIT: 'Main A/C Unit',
  MAIN_COOLING_SW_PUMPS: 'Main Cooling SW Pumps',
  MAIN_ENGINE: 'Main Engine',
  MAIN_ENGINE_FUEL_OIL_HEATER: 'Main Engine Fuel Oil Heater',
  MAIN_ENGINE_FW_HEATER: 'Main Engine FW Heater',
  MAIN_ENGINE_JACKET_COOLER: 'Main Engine Jacket Cooler',
  MAIN_ENGINE_TELEGRAPH_SYSTEM: 'Main Engine Telegraph System',
  MANOEUVRING_SYSTEM: 'Manoeuvring System',
  ME_LO_PUMP: 'ME LO Pump',
  MEDICAL_OXYGEN: 'Medical Oxygen',
  MF_HF: 'MF/HF',
  MGO_TRANSFER_PUMP: 'MGO Transfer Pump',
  MGPS: 'MGPS',
  MOORING_ROPES: 'Mooring Ropes',
  MSB: 'MSB',
  NAVTEX: 'Navtex',
  NITROGEN_GENERATOR: 'Nitrogen Generator',
  ODME: 'ODME',
  OIL_ANALYSIS: 'Oil Analysis',
  OIL_COOLERS: 'Oil Coolers',
  OIL_MIST_DETECTOR: 'Oil Mist Detector',
  OVERFILL_SYSTEM: 'Overfill System',
  OWS: 'OWS',
  OWS_OIL_CONTENT_METER: 'OWS Oil Content Meter',
  OXYGEN_ANALYZER: 'Oxygen Analyzer',
  PIPING_AND_INSULATION: 'Piping and Insulation',
  PISTONS: 'Pistons',
  PORTABLE_FIRE_EXTINGUISHERS: 'Portable Fire Extinguishers',
  PORTABLE_GAS_DETECTORS: 'Portable Gas Detectors',
  POWER_MANAGEMENT_SYSTEM: 'Power Management System',
  PRE_PURCHASING_SURVEYS: 'Pre-Purchasing Surveys',
  PRESSURE_TEMPERATURE_CALIBRATORS: 'Pressure & Temperature Calibrators',
  PROPELLER: 'Propeller',
  PROVISION_CRANES: 'Provision Cranes',
  PROVISION_PLANT: 'Provision Plant',
  PUMP_ROOM_EXHAUST_FANS: 'Pump Room Exhaust Fans',
  PURIFIER_FUEL_OIL_HEATER: 'Purifier Fuel Oil Heater',
  PURIFIER_LUBRICATING_OIL_HEATERS: 'Purifier Lubricating Oil Heaters',
  PURIFIERS: 'Purifiers',
  RADIO_SURVEY_ITEMS: 'Radio Survey Items',
  REMOTE_CONTROLLED_VALVES: 'Remote Controlled Valves',
  RUDDER: 'Rudder',
  SAFETY_AND_PV_VALVES: 'Safety and PV Valves',
  SART: 'SART',
  SCR_NOX_SPOT_CHECK: 'SCR NOx Spot Check',
  SCRUBBER: 'Scrubber',
  SCRUBBER_CSW_PUMPS: 'Scrubber CSW Pumps',
  SEA_TRIALS: 'Sea Trials',
  SEWAGE_PUMPS: 'Sewage Pumps',
  SEWAGE_TREATMENT_PLANT: 'Sewage Treatment Plant',
  SHAFT_GENERATOR: 'Shaft Generator',
  SLUDGE_PUMP: 'Sludge Pump',
  SLUDGE_SLOP_BILGE_SHORE_FACILITY_DISCHARGE:
    'Sludge/Slop/Bilge Shore Facility Discharge',
  SPEED_LOG: 'Speed Log',
  SSAS: 'SSAS',
  STEAM_CONDENSERS: 'Steam Condensers',
  STEEL_STRUCTURE: 'Steel Structure',
  STEERING_GEAR: 'Steering Gear',
  STERN_TUBE: 'Stern Tube',
  STRIPPING_PUMPS: 'Stripping Pumps',
  STUFFING_BOX: 'Stuffing Box',
  SURFACE_COATING: 'Surface Coating',
  S_BAND: 'S-Band',
  TAIL_SHAFT: 'Tail Shaft',
  TANKS: 'Tanks',
  TANK_CLEANING_MACHINES: 'Tank Cleaning Machines',
  TANK_LEVEL_DRAFT_GAUGING_SYSTEM: 'Tank Level/Draft Gauging System',
  THRUSTERS: 'Thrusters',
  TURBOCHARGER: 'Turbocharger',
  UNANNOUCED_DRUG_AND_ALCOHOL_TEST: 'Unannouced Drug and Alcohol Test',
  UNDERWATER_HULL_AND_APPENDICES: 'Underwater Hull and Appendices',
  UTI: 'UTI',
  VACUUM_PUMPS: 'Vacuum Pumps',
  VDR: 'VDR',
  VHF: 'VHF',
  VISCOMETER: 'Viscometer',
  WATER_ANALYSIS: 'Water Analysis',
  WATER_SPRAY_SYSTEM: 'Water Spray System',
  WEATHER_FACSIMILE_RECEIVER: 'Weather Facsimile Receiver',
  WELDING_SAFETY_INSPECTION: 'Welding Safety Inspection',
  WINDLASS: 'Windlass',
  WORKING_AIR_COMPRESSOR: 'Working Air Compressor',
  X_BAND: 'X-Band',
};

const status = {
  PENDING: 'pending approval',
  APPROVED: 'approved',
  EXPIRED: 'expired',
};

const shipType = {
  BULK_CARRIER: 'Bulk Carrier',
  CONTAINERSHIP: 'Containership',
  DREDGER: 'Dredger',
  FPSO: 'FPSO',
  HEAVY_LIFT: 'Heavy Lift',
  GAS_CARRIER: 'Gas Carrier',
  PASSENGER: 'Passenger',
  RO_RO: 'Ro-Ro',
  SUPPLY_VESSEL: 'Supply Vessel',
  TANKER: 'Tanker',
};

const countries = {
  ALBANIA: 'Albania',
  ALGERIA: 'Algeria',
  ANGOLA: 'Angola',
  ANTIGUA: 'Antigua',
  ARGENTINA: 'Argentina',
  ARUBA: 'Aruba',
  ASCENSION_ISLAND: 'Ascension Island',
  AUSTRALIA: 'Australia',
  AZERBAIJAN: 'Azerbaijan',
  BAHAMAS: 'Bahamas',
  BAHRAIN: 'Bahrain',
  BANGLADESH: 'Bangladesh',
  BARBADOS: 'Barbados',
  BELGIUM: 'Belgium',
  BELIZE: 'Belize',
  BENIN: 'Benin',
  BERMUDA: 'Bermuda',
  BRAZIL: 'Brazil',
  BRUNEI_DARUSSALAM: 'Brunei Darussalam',
  BULGARIA: 'Bulgaria',
  CAMBODIA: 'Cambodia',
  CAMEROON_REPUBLIC: 'Cameroon Republic',
  CANADA: 'Canada',
  CAPE_VERDE_ISLANDS: 'Cape Verde Islands',
  CAYMAN_ISLANDS: 'Cayman Islands',
  CHILE: 'Chile',
  CHINA: 'China',
  CHRISTMAS_ISLAND: 'Christmas Island',
  COCOS_IS: 'Cocos Is',
  COLOMBIA: 'Colombia',
  COMOROS: 'Comoros',
  CONGO: 'Congo',
  COOK_ISLANDS: 'Cook Islands',
  COSTA_RICA: 'Costa Rica',
  CROATIA: 'Croatia',
  CUBA: 'Cuba',
  CYPRUS: 'Cyprus',
  DENMARK: 'Denmark',
  DJIBOUTI: 'Djibouti',
  DOMINICA: 'Dominica',
  DOMINICAN_REPUBLIC: 'Dominican Republic',
  ECUADOR: 'Ecuador',
  EGYPT: 'Egypt',
  EL_SALVADOR: 'El Salvador',
  EQUATORIAL_GUINEA: 'Equatorial Guinea',
  ERITREA: 'Eritrea',
  ESTONIA: 'Estonia',
  FALKLAND_ISLANDS: 'Falkland Islands',
  FAROES: 'Faroes',
  FIJI: 'Fiji',
  FINLAND: 'Finland',
  FRANCE: 'France',
  FRENCH_GUIANA: 'French Guiana',
  FRENCH_POLYNESIA: 'French Polynesia',
  GABON: 'Gabon',
  GAMBIA: 'Gambia',
  GEORGIA: 'Georgia',
  GERMANY: 'Germany',
  GHANA: 'Ghana',
  GIBRALTAR: 'Gibraltar',
  GREECE: 'Greece',
  GREENLAND: 'Greenland',
  GRENADA: 'Grenada',
  GUADELOUPE: 'Guadeloupe',
  GUAM: 'Guam',
  GUATEMALA: 'Guatemala',
  GUINEA: 'Guinea',
  GUYANA: 'Guyana',
  HAITI: 'Haiti',
  HONDURAS: 'Honduras',
  HONG_KONG: 'Hong Kong',
  ICELAND: 'Iceland',
  INDIA: 'India',
  INDONESIA: 'Indonesia',
  IRAN: 'Iran',
  IRAQ: 'Iraq',
  IRELAND: 'Ireland',
  ISRAEL: 'Israel',
  ITALY: 'Italy',
  IVORY_COAST: 'Ivory Coast',
  JAMAICA: 'Jamaica',
  JAPAN: 'Japan',
  JORDAN: 'Jordan',
  KENYA: 'Kenya',
  KIRIBATI: 'Kiribati',
  NORTH_KOREA: 'North Korea',
  SOUTH_KOREA: 'South Korea',
  KUWAIT: 'Kuwait',
  LATVIA: 'Latvia',
  LEBANON: 'Lebanon',
  LIBERIA: 'Liberia',
  LIBYA: 'Libya',
  LITHUANIA: 'Lithuania',
  MACAO: 'Macao',
  MADAGASCAR: 'Madagascar',
  MALAYSIA: 'Malaysia',
  MALDIVES: 'Maldives',
  MALTA: 'Malta',
  MARSHALL_ISLANDS: 'Marshall Islands',
  MARTINIQUE: 'Martinique',
  MAURITANIA: 'Mauritania',
  MAURITIUS: 'Mauritius',
  MEXICO: 'Mexico',
  MICRONESIA: 'Micronesia',
  MONACO: 'Monaco',
  MONTSERRAT: 'Montserrat',
  MOROCCO: 'Morocco',
  MOZAMBIQUE: 'Mozambique',
  MYANMAR: 'Myanmar',
  NAMIBIA: 'Namibia',
  NAURU: 'Nauru',
  NETHERLANDS: 'Netherlands',
  NETHERLANDS_ANTILLES: 'Netherlands Antilles',
  NEW_CALEDONIA: 'New Caledonia',
  NEW_ZEALAND: 'New Zealand',
  NICARAGUA: 'Nicaragua',
  NIGERIA: 'Nigeria',
  NORWAY: 'Norway',
  OMAN: 'Oman',
  PAKISTAN: 'Pakistan',
  PANAMA: 'Panama',
  PAPUA_NEW_GUINEA: 'Papua New Guinea',
  PERU: 'Peru',
  PHILIPPINES: 'Philippines',
  POLAND: 'Poland',
  PORTUGAL: 'Portugal',
  PUERTO_RICO: 'Puerto Rico',
  QATAR: 'Qatar',
  REUNION: 'Reunion',
  ROMANIA: 'Romania',
  RUSSIA: 'Russia',
  SAMOA: 'Samoa',
  SAO_TOME: 'Sao Tome',
  SAUDI_ARABIA: 'Saudi Arabia',
  SENEGAL: 'Senegal',
  SEYCHELLES: 'Seychelles',
  SIERRA_LEONE: 'Sierra Leone',
  SINGAPORE: 'Singapore',
  SLOVENIA: 'Slovenia',
  SOLOMON_ISLANDS: 'Solomon Islands',
  SOMALIA: 'Somalia',
  SOUTH_AFRICA: 'South Africa',
  SPAIN: 'Spain',
  SRI_LANKA: 'Sri Lanka',
  ST_HELENA_ISLAND: 'St. Helena Island',
  ST_KITTS_NEVIS: 'St. Kitts & Nevis',
  ST_LUCIA: 'St. Lucia',
  ST_PIERRE_AND_MIQUELON: 'St. Pierre And Miquelon',
  ST_VINCENT: 'St. Vincent',
  SUDAN: 'Sudan',
  SURINAME: 'Suriname',
  SWEDEN: 'Sweden',
  SWITZERLAND: 'Switzerland',
  SYRIA: 'Syria',
  TAIWAN: 'Taiwan',
  TANZANIA: 'Tanzania',
  THAILAND: 'Thailand',
  TOGO: 'Togo',
  TONGA: 'Tonga',
  TRINIDAD_TOBAGO: 'Trinidad & Tobago',
  TUNISIA: 'Tunisia',
  TURKEY: 'Turkey',
  TURKMENISTAN: 'Turkmenistan',
  TURKS_CAICOS_ISLANDS: 'Turks & Caicos Islands',
  TUVALU: 'Tuvalu',
  UKRAINE: 'Ukraine',
  UNITED_ARAB_EMIRATES: 'United Arab Emirates',
  UNITED_KINGDOM: 'United Kingdom',
  UNITED_STATES: 'United States',
  URUGUAY: 'Uruguay',
  VANUATU: 'Vanuatu',
  VENEZUELA: 'Venezuela',
  VIETNAM: 'Vietnam',
  VIRGIN_ISLANDS_BRITISH: 'Virgin Islands British',
  VIRGIN_ISLANDS_US: 'Virgin Islands U.S.',
  WESTERN_SAHARA: 'Western Sahara',
  YEMEN: 'Yemen',
  MONTENEGRO: 'Montenegro',
};

const PaymentTerms = {
  PRE_PAYMENT: 'Pre-payment',
  CASH_ON_BOARD: 'Cash on board',
  AFTER_7_DAYS: 'After 7 days',
  AFTER_14_DAYS: 'After 14 days',
  AFTER_30_DAYS: 'After 30 days',
  AFTER_60_DAYS: 'After 60 days',
  AFTER_90_DAYS: 'After 90 days',
};

const SparePartType = {
  ORIGINAL: 'Original',
  OEM: 'OEM',
  NON_ORIGINAL: 'Non-orginal',
  RECONDITIONED: 'Reconditioned',
};

const OfferType = {
  LUMP_SUM: 'Lump-sum',
  MAN_HOURS: 'Man-hours',
  UNDERWATER: 'UNDERWATER',
};

const OfferStatusType = {
  DRAFT: 'Draft',
  NEW: 'New',
  ACCEPTED: 'Accepted',
  CONFIRMED: 'Confirmed',
  FINALIZED: 'Finalized',
  COMPLETED: 'Completed',
  CANCELED: 'Canceled',
  DECLINED: 'Declined',
  WITHDRAWN: 'Withdrawn',
};

const TransactionStatusType = {
  NEW: 'New',
  REJECTED: 'Rejected',
  PAID: 'Paid',
  INVOICE_SENT: 'Invoice Sent',
  PENDING: 'Pending',
};

const TransactionTypeType = {
  NOBUNDLE: 'No bundle',
  BUNDLE1: 'Bundle 1',
  BUNDLE2: 'Bundle 2',
  BUNDLE3: 'Bundle 3',
  BUNDLE4: 'Bundle 4',
  BUNDLE5: 'Bundle 5',
  BUNDLE10: 'Bundle 10',
  BUNDLE15: 'Bundle 15',
  BUNDLE20: 'Bundle 20',
  BUNDLE30: 'Bundle 30',
  BUNDLE50: 'Bundle 50',
  BUNDLE100: 'Bundle 100',
  BUNDLE200: 'Bundle 200',
  FIXED: 'Fixed',
  YEARLY: 'Yearly',
};

const SubscriptionStatus = {
  NONE: 'None',
  ACTIVE: 'Active',
  CANCEL_REQUESTED: 'Cancel requested',
  CANCELED: 'Canceled',
};

const TimeUnit = {
  DAYS: 'days',
  HOURS: 'hours',
};

const UnderwaterJobs = {
  PROPELLER: 'Propeller',
  PROPELLER_POLISHING: 'Propeller polishing',
  HULL_INSPECTION: 'Hull Inspection',
  VERTICAL_SIDES: 'Vertical sides cleaning',
  FLAT_BOTTOM: 'Flat bottom cleaning',
};

const UnderwaterStandardJobs = {
  BOAT_HIRE: 'Boat hire',
  MOBILIZATION_DEMOBILIZATION: 'Mobilization/demobilization',
};

const Departments = {
  ELECTRONICS: 'Electronics',
  FLEET1: 'Fleet 1',
  FLEET2: 'Fleet 2',
  FLEET3: 'Fleet 3',
  FLEET4: 'Fleet 4',
  FLEET5: 'Fleet 5',
  FLEET6: 'Fleet 6',
  FLEET7: 'Fleet 7',
  FLEET8: 'Fleet 8',
  FLEET9: 'Fleet 9',
  IT: 'IT',
  MARINE: 'Marine',
  OPERATIONS: 'Operations',
  PURCHASING: 'Purchasing',
  RADIO: 'Radio',
  SAFETY: 'Safety',
  TECHNICAL: 'Technical',
  TECHNICAL1: 'Technical 1',
  TECHNICAL2: 'Technical 2',
  TECHNICAL3: 'Technical 3',
  TECHNICAL4: 'Technical 4',
  TECHNICAL5: 'Technical 5',
  TECHNICAL6: 'Technical 6',
  TECHNICAL7: 'Technical 7',
  TECHNICAL8: 'Technical 8',
  TECHNICAL9: 'Technical 9',
  VETTING: 'Vetting',
};

const enums = {
  ...Departments,
  ...equipmentCategory,
  ...equipmentSubcategory,
  ...equipmentTitle,
  ...status,
  ...shipType,
  ...countries,
  ...PaymentTerms,
  ...SparePartType,
  ...OfferType,
  ...OfferStatusType,
  ...TransactionStatusType,
  ...TransactionTypeType,
  ...SubscriptionStatus,
  ...TimeUnit,
  ...UnderwaterJobs,
  ...UnderwaterStandardJobs,
};

export const toEnum = (value: string): string =>
  value
    .toUpperCase()
    .replace(/-/g, '_')
    .replace(/ /g, '_')
    .replace(/\//g, '_')
    .replace(/'/g, '')
    .replace(/\(/g, '')
    .replace(/\)/g, '')
    .replace(/\./g, '')
    .replace(/&/g, '')
    .replace(/__/g, '_')
    .replace(/^(?!_)3D_SCANNING/g, '_3D_SCANNING');

export const fromEnum = (value: string): string =>
  enums[value] ? enums[value] : value;
